import React, { memo } from 'react';
import { Button } from 'react-bootstrap';
import FalconLightBoxGallery from '../FalconLightBoxGallery';
import PropTypes from 'prop-types';

const ImageRenderer = ({ value }) => {
    if (!value?.length) return <></>;

    return (
        <FalconLightBoxGallery images={value.map(p => p.path)}>
            {setImgIndex => (<Button variant="primary" type='button' size="sm" onClick={() => setImgIndex(0)}>
                View
            </Button>)}
            {/* {setImgIndex => (
                <div className="d-flex gap-2">
                    {value.map((p, idx) => (
                        <Image
                            key={p.id}
                            src={p.path}
                            alt={p.notes}
                            onClick={() => setImgIndex(idx)}
                            style={{
                                width: 150,
                                height: 150,
                                objectFit: 'cover',
                                borderRadius: 6,
                                cursor: 'pointer'
                            }}
                            loading="lazy"
                        />
                    ))}
                </div>
            )} */}
        </FalconLightBoxGallery>
    );
};

ImageRenderer.propTypes = {
    value: PropTypes.array,
}

export default memo(ImageRenderer);